export enum AlertLevel {
  information, warning, error, success
}

export default AlertLevel;
